import { h, Component } from 'preact';
import style from './style';
import dlv from 'dlv';
import { getPageConfig } from '../../../lib/device';
import { SadlibAd } from '../../pieces/sadlib-ad';
import { Icon } from '@cube/blocks';
import cx from 'classnames';
import { TrackingProvider, DIMENSION, trackProps } from '@cube/track';

const HERO_BREAKPOINT = 1160;
const Options = (props) => (
	<div class={style.optionCluster}>
		{[...props.options].map((card, i) => (
			<a
				{...trackProps(
					{
						[DIMENSION.componentpath]: 'SpeedOptions',
						[DIMENSION.clickindex]: i + 1,
						[DIMENSION.text]: card?.title
					},
					props?.context
				)}
				href={dlv(card, 'link.href')}
				target={dlv(card, 'link.open_new_window') ? '_blank' : '_self'}
				rel="noreferrer"
			>
				<div class={style.optionCard}>
					<div class={style.optionTitle}>{card?.title}</div>
					<div class={style.optionDescription}>{card?.description}</div>
				</div>
			</a>
		))}
	</div>
);
export default class SpeedClusterP25 extends Component {
	handleImageClick = () => {
		this.setState({ showIframe: true, iframeLoading: true });
	};
	handleLoad = () => {
		this.setState({ iframeLoading: false });
	};
	componentWillMount() {
		let pageConfig = getPageConfig(this.props?.pageConfig, 'Desktop');
		this.setState({ pageConfig });
	}

	render({ qeId,...props }, { pageConfig, showIframe, iframeLoading }) {
		const width = this.props.width;
		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: 'SpeedCluster' }}>
				<div class={style.speedContainer} id={qeId}>
					<div class={style.speedFlex}>
						<div class={style.speedAd}>
							<SadlibAd
								id="home_p25_desktop_speedCluster_adContainer"
								type="desktopRail"
							/>
						</div>

						<TrackingProvider {...{ [DIMENSION.componentpath]: 'Speed-Test' }}>
							<div class={style.speedWidget}>
								{showIframe ? (
									<div style="text-align:right;">
										<div class={style.openSpeedTestContainer}>
											<div class={style.iframeContainer}>
												<iframe
													onLoad={this.handleLoad}
													class={style.speedTestIFrame}
													src="//openspeedtest.com/speedtest"
												/>
												{iframeLoading && (
													<div class={style.loadingContainer}>
														<div
															className={cx(
																style.iframePlaceholder,
																style.fadeAnimation
															)}
														>
															<Icon
																name="speed-test-wire-cube"
																class={style.speedIcon}
															/>
															<div class={style.title}>Internet Speed Test</div>
															<div class={style.subtitle}>Get Started</div>
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
								) : (
									<div class={style.iframePlaceholder}>
										<Icon name="speed-test-wire-cube" class={style.speedIcon} />
										<div class={style.title}>Internet Speed Test</div>
										<div
											onClick={this.handleImageClick}
											class={style.subtitle}
											{...trackProps(
												{
													[DIMENSION.componentpath]: 'SpeedTest'
												},
												this.context
											)}
										>
											Get Started
										</div>
									</div>
								)}
							</div>
						</TrackingProvider>

						{width > HERO_BREAKPOINT && (
							<div class={style.speedWidgetOptions}>
								<Options
									options={[...dlv(pageConfig, 'clusters.speed.options')]}
									context={this.context}
								/>
							</div>
						)}
					</div>

					{width < HERO_BREAKPOINT && (
						<div class={style.speedWidgetOptions}>
							<Options
								options={[...dlv(pageConfig, 'clusters.speed.options')]}
								context={this.context}
							/>
						</div>
					)}

					<div class={style.speedSub}>
						<div class={style.speedFAQs}>
							<div class={style.speedFAQCluster}>
								{[...dlv(pageConfig, 'clusters.speed.faq')].map((card, i) => (
									<a
										{...trackProps(
											{
												[DIMENSION.componentpath]: 'SpeedFAQs',
												[DIMENSION.clickindex]: i + 1,
												[DIMENSION.text]: card?.title
											},
											this.context
										)}
										href={dlv(card, 'link.href')}
										target={
											dlv(card, 'link.open_new_window') ? '_blank' : '_self'
										}
										rel="noreferrer"
									>
										<div class={style.faqCard}>
											<div class={style.faqTitle}>{card?.title}</div>
											<Icon name="navigate-right-cube" class={style.icon} />
										</div>
									</a>
								))}
							</div>
						</div>
					</div>
				</div>
			</TrackingProvider>
		);
	}
}
